import { ResponseHelper } from '../_helpers/response.helper'
import axiosInstance from './axios.service'

export class StreamService {
    private setError: (message: string | null) => void

    constructor(setError: (message: string | null) => void) {
        this.setError = setError
    }

    async getStreamStatus() {
        return axiosInstance
            .get('/stream/status')
            .then(res => res.data.data)
            .catch(e => ResponseHelper.handleError(e, this.setError))
    }

    async getStreamLink() {
        return axiosInstance
            .get('/stream/link')
            .then(res => res.data.data)
            .catch(e => ResponseHelper.handleError(e, this.setError))
    }

    async getRecent() {
        return axiosInstance
            .get('/stream/recent')
            .then(res => res.data.data)
            .catch(e => ResponseHelper.handleError(e, this.setError))
    }

    async postMessage(message: string, sessionId: string) {
        return axiosInstance
            .post('/stream/message', { message, sessionId })
            .then(res => res.data.data)
            .catch(e => ResponseHelper.handleError(e, this.setError))
    }
}
